import React from "react";
import { Link } from "react-router-dom";
import * as actions from '../Actions';
import Service from '../../service/Service';
const service = new Service();

export default function DiscussionActionCounts({ discussion, eleRef }) {
    return (
        <div className="discussion-detail">
            {discussion.commentCount != 0 &&
                <Link to={service.getRedirectUrl(`/discussions/t/${service.replaceSymbols((actions.only_title(discussion.title)) + '-' + (discussion.discussionId))}?cid=${discussion.discussionId}&pt=0`)} className="disc_comments" data-count={discussion.commentCount}>
                    <span className="L10_61 discussion_comments"> {service.intToString(discussion.commentCount)} Comments </span>
                </Link>
            }
            <span className="disc_followers" data-count={discussion.followCount} onClick={() => actions.followersList(discussion.discussionId, discussion.followCount)}>
                <span className="L10_61 discussion_followers">{service.intToString(discussion.followCount)} Followers </span>
            </span>
            <span className="disc_participants" data-count={discussion.participantCount} onClick={() => actions.participantList(discussion.discussionId, discussion.participantCount)}>
                <span className="L10_61 discussion_participants"> {service.intToString(discussion.participantCount)} Participants </span>
            </span>
            <span className="disc_views">
                <span className="L10_61 discussion_views"> {service.intToString(discussion.viewCount)} Views </span>
            </span>
        </div>
    );
}


// WEBPACK FOOTER //
// src/shared/discussions/common/DiscussionActionCounts.js